module.exports = __webpack_public_path__ + "static/media/006.29981cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/006.jpg
// module id = 513
// module chunks = 0